import Duck from 'extensible-duck';
import Immutable from 'immutable';
import requestsManager from 'lib/requestsManagerAxios';
import { createSelector } from 'reselect';

export default new Duck({
  namespace: 'organization-config',
  store: 'notificationBadge',
  types: [
    'FETCH_NOTIFICATIONS',
    'FETCH_NOTIFICATIONS_PENDING',
    'FETCH_NOTIFICATIONS_FULFILLED',
    'FETCH_NOTIFICATIONS_REJECTED',
    'UPDATE_NOTIFICATIONS',
    'UPDATE_NOTIFICATIONS_PENDING',
    'UPDATE_NOTIFICATIONS_FULFILLED',
    'UPDATE_NOTIFICATIONS_REJECTED',
  ],
  initialState: Immutable.fromJS({
    $$notifications: [],
    fetchNotificationsPending: true,
    sinceLastClickedCount: 0,
  }),
  reducer: ($$state, { type, payload, meta }, { types }) => {
    switch (type) {
      case types.FETCH_NOTIFICATIONS_PENDING:
        return $$state.merge({ fetchNotificationsPending: true });
      case types.FETCH_NOTIFICATIONS_REJECTED:
        return $$state.merge({ fetchNotificationsPending: false });
      case types.FETCH_NOTIFICATIONS_FULFILLED:
        return $$state.merge({
          fetchNotificationsPending: false,
          $$notifications: Immutable.fromJS(payload.data.notifications),
          sinceLastClickedCount: payload.data.sinceLastClickedCount,
        });
      case types.UPDATE_NOTIFICATIONS_FULFILLED:
        return $$state.merge({ sinceLastClickedCount: 0 });
      case types.UPDATE_NOTIFICATIONS_REJECTED:
        return $$state.merge({ sinceLastClickedCount: 0 });
      default:
        return $$state;
    }
  },
  selectors: {},
  creators: ({ types }) => ({
    fetchNotifications: () => ({
      type: types.FETCH_NOTIFICATIONS,
      payload: requestsManager.fetchEntities('/admin/notifications'),
    }),
    updateNotifications: () => ({
      type: types.UPDATE_NOTIFICATIONS,
      payload: requestsManager.patch('/admin/notifications'),
    }),
  }),
});
